/*
 * @Author: bbqin
 * @Date: 2023-02-14 10:54:06
 * @LastEditTime: 2023-08-10 11:33:06
 * @LastEditors: bbqin
 * @Description: 在这里包装下，后面替换和修改会比较容易
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\container\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';
import { Tabs } from '@platform/base';

require('./index.less');
const { TabPane } = Tabs;

class ContainerItem extends Component {
    render() {
        let { className = '', ...others } = this.props;
        return <TabPane {...this.props} className={className + ' smart-card-container-item '} />;
    }
}

class Container extends Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
    }

    render() {
        let { className = '', ...others } = this.props;
        const tabPaneArray = [];
        React.Children.forEach(this.props.children, (element, index) => {
            if (element &&
                ((element.type && element.type.name === ContainerItem.name) ||
                    (element.props && element.props.tab))) { // 给设计器用
                // key 使用 moduleId
                element.key = element?.props?.moduleId || element.key;
                tabPaneArray.push(element);
            }
        });
        return <Tabs
            {...this.props}
            className={className + ' smart-card-container '}
        >
            {tabPaneArray}
        </Tabs>;
    }
}
Container.ContainerItem = ContainerItem;

export default Container;